var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "my-8 mt-2 flex lg:inline-flex justify-between items-center"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.user.isAdmin
            ? _c(
                "button",
                {
                  staticClass: "button lg:ml-4",
                  attrs: { type: "button" },
                  on: { click: _vm.showAddMeeting }
                },
                [_vm._m(1), _vm._v(" "), _c("span", [_vm._v("Add New")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.user.isAdmin
            ? _c(
                "button",
                {
                  staticClass: "button lg:ml-4",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.toggleShowArchived()
                    }
                  }
                },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.showArchived
                          ? "Hide Archived Meetings"
                          : "Show Archived Meetings"
                      ) + "\n      "
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "columns mb-8" }, [
        _c("div", { staticClass: "column" }, [
          !_vm.user.username
            ? _c("div", [
                _vm._v("\n        You are currently not logged in.\n      ")
              ])
            : !_vm.user.isAdmin &&
              !_vm.upcomingMeetings.length &&
              !Object.keys(_vm.user.meetings).length
            ? _c("div", [
                _vm._v(
                  "\n        There are currently no meetings available.\n      "
                )
              ])
            : _c("div", { staticClass: "box" }, [
                _c(
                  "table",
                  { staticClass: "table is-fullwidth table-with-data-labels" },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.meetingsList, function(meeting) {
                          return _c("tr", { key: meeting.id }, [
                            _c(
                              "td",
                              { attrs: { "data-label": "Name" } },
                              [
                                _vm.user.isAdmin
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "MeetingDashboard",
                                                params: { id: meeting.id }
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(meeting.name))]
                                        ),
                                        _vm._v(
                                          "\n                  (Maxx ID: " +
                                            _vm._s(meeting.maxxId) +
                                            ")"
                                        )
                                      ],
                                      1
                                    )
                                  : _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "UserSuites",
                                            params: { id: meeting.id }
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(meeting.name))]
                                    )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", {
                              attrs: { "data-label": "Dates" },
                              domProps: {
                                textContent: _vm._s(
                                  _vm.formatTime(meeting.start_date) +
                                    " - " +
                                    _vm.formatTime(meeting.end_date)
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("td", { attrs: { "data-label": "Status" } }, [
                              _c("span", {
                                staticClass: "tag is-uppercase",
                                class: _vm.phases[meeting.phase_index].style,
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.phases[meeting.phase_index].text
                                  )
                                }
                              }),
                              _vm._v(" "),
                              meeting.is_archived
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "tag is-uppercase is-black"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Archived\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.upcomingMeetings, function(meeting) {
                          return _c("tr", { key: meeting.id }, [
                            _c("td", { attrs: { "data-label": "Name" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(meeting.name) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", {
                              attrs: { "data-label": "Dates" },
                              domProps: {
                                textContent: _vm._s(
                                  _vm.formatTime(meeting.start_date) +
                                    " - " +
                                    _vm.formatTime(meeting.end_date)
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("td", { attrs: { "data-label": "Status" } }, [
                              _c("span", {
                                staticClass: "tag is-uppercase",
                                domProps: {
                                  textContent: _vm._s(
                                    "Scheduling begins " +
                                      _vm.formatTime(meeting.scheduler_date) +
                                      "."
                                  )
                                }
                              })
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  ]
                )
              ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.showingAddMeeting,
            "trap-focus": "",
            width: 700
          },
          on: {
            "update:active": function($event) {
              _vm.showingAddMeeting = $event
            },
            close: _vm.hideAddMeeting
          }
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.hideAddMeeting($event)
                }
              }
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v("Add New Meeting")
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "modal-card-body pb-8" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedShowMaxxDupes,
                          expression: "selectedShowMaxxDupes"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.selectedShowMaxxDupes)
                          ? _vm._i(_vm.selectedShowMaxxDupes, null) > -1
                          : _vm.selectedShowMaxxDupes
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.selectedShowMaxxDupes,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.selectedShowMaxxDupes = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedShowMaxxDupes = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedShowMaxxDupes = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(
                      " Show\n            duplicate Maxx meetings\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Select Meeting from Maxx to Link Registrations")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control has-icons-left" }, [
                    _c("div", { staticClass: "select" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedMeeting,
                              expression: "selectedMeeting"
                            }
                          ],
                          class: { "is-loading": _vm.meetingsAreLoading },
                          attrs: { disabled: _vm.meetingsAreLoading },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedMeeting = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Select one...")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.availableMeetings, function(meeting) {
                            return _c(
                              "option",
                              { key: meeting.id, domProps: { value: meeting } },
                              [_vm._v(_vm._s(meeting.name))]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "icon is-left" }, [
                      _c("i", { staticClass: "fas fa-calendar" })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedCopy,
                        expression: "selectedCopy"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.selectedCopy)
                        ? _vm._i(_vm.selectedCopy, null) > -1
                        : _vm.selectedCopy
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.selectedCopy,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.selectedCopy = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedCopy = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedCopy = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.selectedCopy = !_vm.selectedCopy
                        }
                      }
                    },
                    [_vm._v("Copy an Existing Appointment Scheduler Meeting")]
                  )
                ]),
                _vm._v(" "),
                _vm.selectedCopy
                  ? _c("div", { staticClass: "field" }, [
                      _c("div", [
                        _vm.selectedCopy
                          ? _c("div", { staticClass: "select" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.meetingToCopyId,
                                      expression: "meetingToCopyId"
                                    }
                                  ],
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.meetingToCopyId = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { disabled: "", value: "" } },
                                    [_vm._v("Select one...")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.meetings, function(meeting) {
                                    return _c(
                                      "option",
                                      {
                                        key: meeting.id,
                                        domProps: { value: meeting.id }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(meeting.name) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                Object.keys(_vm.timeslotsForCopy).length > 0
                  ? _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Enter Dates for New Meeting")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "control" },
                        _vm._l(_vm.timeslotsForCopy, function(
                          slot,
                          key,
                          index
                        ) {
                          return _c("div", { key: "slotindex" + index }, [
                            _c(
                              "div",
                              { staticClass: "field is-grouped mb-4" },
                              [
                                _c("div", { staticClass: "label mr-4" }, [
                                  _vm._v("Day " + _vm._s(index + 1) + ":")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "control" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.copyDates[index],
                                        expression: "copyDates[index]"
                                      }
                                    ],
                                    staticClass: "input",
                                    attrs: { type: "date", required: "" },
                                    domProps: { value: _vm.copyDates[index] },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.copyDates,
                                          index,
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Display Name")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newMeetingName,
                        expression: "newMeetingName"
                      }
                    ],
                    staticClass: "input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.newMeetingName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.newMeetingName = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "help" }, [
                    _vm._v(
                      "\n            The display name for the meeting in the scheduler. If left blank,\n            will be the same as the Maxx meeting name.\n          "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-success",
                    on: { click: _vm.addMeeting }
                  },
                  [_vm._v("\n          Add To Scheduler\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button is-text",
                    attrs: { type: "button" },
                    on: { click: _vm.hideAddMeeting }
                  },
                  [_vm._v("\n          Cancel\n        ")]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "title text-md lg:text-2xl m-0" }, [
      _c("span", [_vm._v("Select a Meeting")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-folder-open" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Meeting Name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Dates")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Status")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60b70f86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b70f86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MeetingsList.vue
// module id = null
// module chunks = 